webpackJsonp([78207197725749],{

/***/ 1345:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AnalyticsFieldModifier","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"field","type":{"kind":"ENUM","name":"AnalyticsField","ofType":null}},{"defaultValue":null,"description":null,"name":"modifiers","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-analytics-field-modifier-43f00d4a1edee6f9b5c1.js